import React, { useState } from 'react';
import { Show, TabbedShowLayout, useCreatePath, Loading, useShowContext, useAuthProvider } from 'react-admin';
import { Container } from '@mui/material';

import { Theme } from 'src/Theme';
import { tabbedContainerStyles } from 'src/styles';
import { ShsReturnButton } from 'src/components/common';
import TopToolbar from './TopToolbar';
import GeneralTab from './GeneralTab';
import SchedulerTab from './SchedulerTab';
import ChildReportTab from './ChildReportTab';
import { AdminGroup } from 'src/constants/roles';

const tabbedLayoutStyles = {
    '& .RaTabbedShowLayout-content:has(.show-page-container.scheduler)': {
        padding: 0
    }
};

export const ChildShow: React.FC = () => {
    const authProvider = useAuthProvider();
    const { isLoading } = useShowContext();
    const createPath = useCreatePath();
    const [isActive, setIsActive] = useState(false);
    const isSchedulerEnabled = false;

    const getIsActive = (isActive: boolean) => {
        setIsActive(isActive);
    };

    const hasEditPermission = authProvider?.containsRoles(AdminGroup) ?? false;

    if (isLoading) {
        return <Loading />;
    }
    return (
        <Container maxWidth={false} sx={tabbedContainerStyles}>
            <ShsReturnButton to={createPath({ resource: 'children', type: 'list' })} label="Назад до списку дітей" />
            <Show
                className="show-page-container"
                queryOptions={{ meta: { useMock: false } }}
                actions={<TopToolbar setIsActive={getIsActive} hasEditPermission={hasEditPermission} />}>
                <TabbedShowLayout sx={tabbedLayoutStyles}>
                    <TabbedShowLayout.Tab label="Загальна інформація">
                        <GeneralTab hasEditPermission={hasEditPermission} />
                    </TabbedShowLayout.Tab>
                    {isSchedulerEnabled && isActive && (
                        <TabbedShowLayout.Tab label="Розклад учня" path="scheduler">
                            <SchedulerTab />
                        </TabbedShowLayout.Tab>
                    )}
                    <TabbedShowLayout.Tab label="Звітність">
                        <ChildReportTab />
                    </TabbedShowLayout.Tab>
                </TabbedShowLayout>
            </Show>
        </Container>
    );
};
